import { allocatePacksForRecipe, PackAllocationResult } from "./PackAllocation";

export interface PackPlanInput {
  gramsPerRecipe: Record<string, number>;
}

export type PackPlan = PackAllocationResult[];

export function buildPackPlan(input: PackPlanInput): PackPlan {
  const results: PackPlan = [];

  for (const [recipeId, grams] of Object.entries(input.gramsPerRecipe)) {
    if (!grams || grams <= 0) continue;

    const allocation = allocatePacksForRecipe({
      recipeId,
      gramsNeeded: grams,
    });

    results.push(allocation);
  }

  return results;
}
